import React, { useState } from "react";
import { I18n } from "../../../../models/I18n";
import { ReportConfigVisibility } from "../../constants/ReportConfigVisibility";
import { camelCaseToSnakeCase } from "../../../../utils/camelCaseToSnakeCase";
import { ReportConfig } from "../../models/ReportConfig";
import style from "./style/SideNavigator.module.scss";

export interface SideNavigatorProps {
    i18n: I18n;
    reportData: any;
    scrollToSection: (elementId: string) => void;
}

export const SideNavigator = ({ i18n, reportData, scrollToSection }: SideNavigatorProps) => {
    const [selectedSection, setSelectedSection] = useState("overview");

    const getSelectedItemClass = (handle: string) => {
        if (selectedSection === handle) {
            return style.selected;
        }
        return "";
    };

    const onItemClick = (handle: string) => {
        setSelectedSection(handle);
        scrollToSection(handle);
    };

    const getNavigatorSectionItems = () =>
        reportData.config.sort((a: ReportConfig, b: ReportConfig) => a.order - b.order).map((reportConfig: ReportConfig) => {
            if (reportConfig.visibility === ReportConfigVisibility.SUMMARY) {
                return null;
            }
            return (
                <div
                    key={reportConfig.i}
                    className={`${style.navigatorItem} ${getSelectedItemClass(reportConfig.i)}`}
                    role="button"
                    tabIndex={1}
                    data-testid={`sidebar-item ${reportConfig.i}`}
                    data-section={reportConfig.i}
                    onClick={() => onItemClick(reportConfig.i)}
                >
                    {i18n[`report_side_navigator_${camelCaseToSnakeCase(reportConfig.i)}`]}
                </div>
            );
        });

    return (
        <div className={style.sideNavigatorWrapper} data-testid="sidebar">
            <div
                className={`${style.navigatorItem} ${getSelectedItemClass("overview")}`}
                role="button"
                tabIndex={1}
                data-testid="sidebar-item overview"
                data-section="overview"
                onClick={() => onItemClick("overview")}
            >
                {i18n.report_side_navigator_overview}
            </div>
            {getNavigatorSectionItems()}
        </div>
    );
};

export default SideNavigator;
